import React, { useState, useEffect } from "react";
import  "../Style/HeaderCaraousel.css";
import f from "../Assets/Header/front.JPG"
import i from "../Assets/Header/inside.JPG"
const HeaderCaraousel = () => {
  const [currentItemIndex, setCurrentItemIndex] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [showText, setShowText] = useState(false);

  const slides = [
    {
      src: f,
    },
    {
      src: i,
    },
  ];

  const carouselItems = [slides[slides.length - 1], ...slides, slides[0]];

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isTransitioning) {
        setShowText(false); // Hide text before the next image transition
        setCurrentItemIndex((prevIndex) => prevIndex - 1);
        setIsTransitioning(true);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [isTransitioning]);

  const handleTransitionEnd = () => {
    setIsTransitioning(false);
    setTimeout(() => setShowText(true), 2000); // Immediately show text with animation
    if (currentItemIndex === 0) {
      setCurrentItemIndex(carouselItems.length - 2);
    } else if (currentItemIndex === carouselItems.length - 1) {
      setCurrentItemIndex(1);
    }
  };

  return (
    <div className="carousel-container">
      <div
        className="carouselInner"
        style={{
          transform: `translateX(-${currentItemIndex * 100}%)`,
          transition: isTransitioning ? "transform 1s ease-in-out" : "none",
        }}
        onTransitionEnd={handleTransitionEnd}
      >
        {carouselItems.map((item, index) => (
          <div key={index} className="carouselSlide">
            <img
              src={item.src}
              alt={`carousel-${index}`}
              className="carouselImage"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeaderCaraousel;
